import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // 引入路由配置
import ElementPlus from 'element-plus'
import { ElMessageBox, ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/../public/css/index.css'
import i18n from './i18n/index'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 配置全局属性
app.config.globalProperties.$msgbox = ElMessageBox
app.config.globalProperties.$message = ElMessage
app.config.globalProperties.$confirm = ElMessageBox.confirm

app.use(ElementPlus)
app.use(i18n)
app.use(router);
app.mount('#app')
